import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

// Frontend Modules
import './modules/waitlist';

console.log('[IPS-React] Main index.tsx geladen (waitlist frontend).');

serviceWorker.unregister();
reportWebVitals();
